<template>
  <div>
    <el-dialog
      title="授权页面"
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
      width="70%"
      appendToBody
      :close-on-click-modal="false"
      destory-on-close
      top="8vh"
    >
      <el-container>
        <el-main style="padding: 10px; height: 530px">
          <form v-form>
            <table class="table table-bordered" style="border-spacing: 0; width: 100%; max-height: 400px; overflow: initial">
              <thead>
                <th style="width: 15%">权限类型</th>
                <th>内容</th>
                <th style="width: 15%">操作</th>
              </thead>
              <tbody>
                <tr v-for="(item, $index) in needSetArr" :key="item.title" :data-index="$index" data-subname="needSetArr" v-show="showSelectors[item.type]">
                  <th>{{ item.title }}</th>
                  <td>
                    <eip-user-selector v-if="item.type == 'user'" :appendToBody="true" v-model="item.name" :config="{ id: 'item.id' }" :key="selectorKey" />
                    <eipRoleSelector v-if="item.type == 'role'" :appendToBody="true" v-model="item.name" :config="{ id: 'item.id' }" :key="selectorKey" />
                    <eipOrgSelector v-if="item.type == 'org'" :appendToBody="true" v-model="item.name" :config="{ id: 'item.id' }" :key="selectorKey" />
                    <eipPostSelector v-if="item.type == 'pos'" :appendToBody="true" v-model="item.name" :config="{ id: 'item.id' }" :key="selectorKey" />
                  </td>
                  <td>
                    <el-button @click="updateNeedSetArr($index)">重置</el-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </form>
        </el-main>
      </el-container>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleClose" size="medium">确 定</el-button>
        <el-button @click="dialogVisible = false" size="medium">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import deepmerge from 'deepmerge'
const eipUserSelector = () => import('@/components/selector/EipUserSelector.vue')
const eipRoleSelector = () => import('@/components/selector/EipRoleSelector.vue')
const eipOrgSelector = () => import('@/components/selector/EipOrgSelector.vue')
const eipPostSelector = () => import('@/components/selector/EipPostSelector.vue')

export default {
  components: {
    eipUserSelector,
    eipRoleSelector,
    eipOrgSelector,
    eipPostSelector
  },
  data() {
    return {
      dialogVisible: false,
      needSetArr: [
        {
          type: 'user',
          title: '用户',
          id: '',
          name: ''
        },
        {
          type: 'org',
          title: '组织',
          id: '',
          name: ''
        },
        {
          type: 'pos',
          title: '岗位',
          id: '',
          name: ''
        },
        {
          type: 'role',
          title: '角色',
          id: '',
          name: ''
        }
      ],
      selectorKey: 1,
      index: 0,
      indexs: 0,
      type: '',
      permissionList: [],
      showSelectors: {
        user: false,
        org: false,
        pos: false,
        role: false
      },
      right: []
    }
  },
  methods: {
    showDialog(params, index, indexs, types) {
      this.index = index
      this.indexs = indexs
      this.type = types
      let param = deepmerge({}, params, { clone: true })
      this.dialogVisible = true
      this.right = ''
      if (param.json.table[index].fields[indexs][types].person) {
        this.right = deepmerge({}, param.json.table[index].fields[indexs][types].person, { clone: true })
      }
      this.permissionList = param.permissionList || []
      let needSetting = []
      for (var i = 0; i < this.permissionList.length; i++) {
        var obj = this.permissionList[i]
        var type = obj.type
        var objRight = this.getRight(this.right, type)
        if (objRight) {
          objRight.title = obj.title
          Object.assign(this.getRight(this.needSetArr, type), objRight)
          needSetting.push(objRight)
          this.showSelectors[objRight.type] = true
        } else {
          if (obj.type != 'everyone') {
            obj.id = ''
            obj.name = ''
            needSetting.push(obj)
            this.showSelectors[obj.type] = true
          }
        }
      }
      this.needSetArr = []
      this.needSetArr = needSetting
    },
    getRight: function (aryRights, type) {
      if (!this.right || this.right.size == 0) return null
      for (var i = 0; i < aryRights.length; i++) {
        var obj = aryRights[i]
        if (obj.type == type) {
          return obj
        }
      }
      return null
    },
    handleClose() {
      let rtn = []
      let setting = this.needSetArr
      for (let i = 0; i < setting.length; i++) {
        let obj = setting[i]
        //设置了值。
        if (obj.id) {
          rtn.push(obj)
        }
      }
      this.$emit('onConfirm', rtn, this.index, this.indexs, this.type)
      this.dialogVisible = false
    },
    updateNeedSetArr(index) {
      this.needSetArr[index].id = ''
      this.needSetArr[index].name = ''
      ++this.selectorKey
    }
  }
}
</script>

<style scoped>
div >>> .el-dialog__body {
  padding: 10px;
}

.table > thead > tr > th,
.table > thead > th,
.table > tbody > tr > th,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > tbody > tr > td,
.table > tfoot > tr > td {
  border-top: 1px solid #e7eaec;
  border-left: 1px solid #e7eaec;
  line-height: 1.42857;
  padding: 8px;
  vertical-align: middle;
}
.table {
  border-bottom: 1px solid #e7eaec;
  border-right: 1px solid #e7eaec;
}
.filed_body >>> .el-button {
  float: right;
}
</style>
